import { InjectionToken } from '@angular/core';

export interface IAuthenticationDataService {
    getAuthData(): any;
}

export const AUTH_DATA_SERVICE_TOKEN = new InjectionToken<IAuthenticationDataService>('IAuthenticationDataService');